import React from "react";
import { Link } from "react-router-dom";
import "./RightBar.css";

const RightBar = (prop) => {

  return (
    <div className="RightBar">
      {prop.RightBarData.map((data,index) => {
        return(
        <div key={data.key}>
          <h2 className="tasks-group__heading" >
            {data.icon}
            {data.label}
          </h2>
          <ul>
          {prop.RightBarData[index].children.map((list) => {
              
            return(
            <li key={list.key}>
              <Link to={list.url} className="task-group-list">
                {list.label}
              </Link>
            </li>
            );
            })}
          </ul>
        {index === prop.RightBarData.length-1 ? '' :
          <hr/>
        }
        </div>
        );
      })}
    </div>
  );
};

export default RightBar;
